import { FC } from 'react';
import styled from 'styled-components';
import { fontSize } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { theme } from '../../../theme';

const Wrapper = styled.div`
  ${fontSize};
  align-items: center;
  border: thin solid ${props => (props.onClick ? themeGet('colors.whites[4]', 'rgba(255,255,255,.2)') : 'transparent')};
  border-radius: ${theme.space[1]}px;
  display: inline-block;
  font-size: ${theme.fontSize[19]};
  font-weight: 400;
  margin: 0 ${theme.space[1]}px;
  padding: ${theme.space[1]}px;
`;

export const AccordionTitleDetailText = styled.span`
  ${fontSize};
`;

export interface AccordionTitleDetailProps {
  text: string | number;
  onClick?: () => void;
  propagateOnClick?: boolean;
  children?: JSX.Element;
}

/**
 * @render react
 * @name AccordionTitleDetail component
 * @description Compact element that represent an input, attribute, or action.
 * @example
 * <AccordionTitleDetail text="Name" />
 */

const AccordionTitleDetail: FC<AccordionTitleDetailProps> = ({
  text,
  onClick,
  propagateOnClick,
  children,
  ...rest
}) => (
  <Wrapper
    onClick={e => {
      if (propagateOnClick === false) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
      }
      if (onClick) {
        onClick();
      }
    }}
  >
    {text && <AccordionTitleDetailText {...rest}>{text}</AccordionTitleDetailText>}
    {children}
  </Wrapper>
);

export default AccordionTitleDetail;
